import React, {FC, ReactNode} from 'react'
import classnames from 'classnames'

// @ts-ignore
import { Close } from '../../../icons'

// @ts-ignore
import styles from './Modal.scss'

type ModalProps = JSX.IntrinsicElements['div'] & {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
}

export const Modal: FC<ModalProps> = ({ isOpen, children, onClose, className, ...props }) => {
  if (!isOpen) { return null }

  return (
    <div onClick={onClose} className={styles.overlay}>
      <div
       {...props}
        onClick={(e) => { e.stopPropagation() }}
        className={classnames(styles.modal, className)}
      >
        {children}
      </div>
    </div>
  )
}

type HeaderProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode
  onClose: () => void
}

export const Header: FC<HeaderProps> = ({ onClose, children, className, ...props }) => {
  return (
    <div className={classnames(styles.header, className)} {...props}>
      {children}
      <Close className={styles.icon} onClick={onClose} />
    </div>
  )
}

type BodyProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode
}

export const Body: FC<BodyProps> = ({ children, className, ...props }) => {
  return (
    <div className={classnames(styles.body, className)} {...props}>
      {children}
    </div>
  )
}

type FooterProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode
}

export const Footer: FC<FooterProps> = ({ children, className, ...props }) => {
  return (
    <div className={classnames(styles.footer, className)} {...props}>
      {children}
    </div>
  )
}
